import { useState, Fragment } from 'react';
import AccordionPanel from './AccordionPanel';
import ComponentHeading from '../../fragments/heading/ComponentHeading';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';

export default function Accordion({ block, index }) {
  const [panels, setPanels] = useState(block?.accordionPanels ?? []);

  const HeadingTag = index === 0 ? 'h1' : 'h2';

  function toggle(id) {
    setPanels((prevPanels) =>
      prevPanels.map((item) => {
        return item.id === id
          ? { ...item, expanded: !item.expanded }
          : // : { ...item, expanded: false };
            { ...item };
      })
    );
  }

  // Guard sits below every hook so the hook order is identical on every render.
  if (!block) return null;

  return (
    <ComponentWrapper block={block} className="Accordion">
      <div className={'l-grid'}>
        {block.heading && (
          <ComponentHeading
            heading={block.heading}
            description={block.description}
            firstBlock={index === 0}
          />
        )}
        <div className="l-grid__col">
          <div className=" Accordion-contentSection">
            {panels && (
              <div className={'Accordion-accordion'}>
                <div className={'Accordion-panels'}>
                  {panels.map((panel, index) => {
                    return (
                      <Fragment key={index}>
                        <AccordionPanel
                          panel={panel}
                          block={block}
                          expanded={panel.expanded}
                          toggle={toggle}
                          index={index}
                        />
                      </Fragment>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
}
